import { string, number, shape } from "prop-types";

const RoomBookShape = shape({
  id: number,
  name: string
});

export default RoomBookShape;
